export const PATH_PARAMETERS_CERTIFICATES = "/parameters/certificates";
export const PATH_PARAMETERS_CERTIFICATES_TRUSTSTORE = `${PATH_PARAMETERS_CERTIFICATES}/truststore`;
export const PATH_PARAMETERS_CERTIFICATES_TRUSTSTORE_ALIAS = `${PATH_PARAMETERS_CERTIFICATES_TRUSTSTORE}/:alias`;
